import { useSyncExternalStore } from 'react';

import Cookies from 'js-cookie';

/*
 * Check if the user is authenticated based on the presence of the bmt_session cookie.
 */
export function isAuthenticated(): boolean {
  const cookies = Cookies.get();
  const cookieKey = Object.keys(cookies).find(key => key.startsWith('_bmt_session_created_at_'));
  return Boolean(cookieKey && cookies[cookieKey]);
}

/**
 * Subscribe to all events that *might* change the authenticated state of the user.
 */
export function onUserStateChange(listener: () => void): () => void {
  document.addEventListener('echo:submit-end', listener);
  return () => document.removeEventListener('echo:submit-end', listener);
}

/**
 * A React hook that will tell you if the user is authenticated.
 */
export function useIsAuthenticated(): boolean {
  return useSyncExternalStore(onUserStateChange, isAuthenticated);
}
